import { render, staticRenderFns } from "./Duvidas.vue?vue&type=template&id=7e512652&"
import script from "./Duvidas.vue?vue&type=script&lang=js&"
export * from "./Duvidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports